/**
 *
 * FileRow
 *
 */
import React, { memo, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// antd component
import { Form, Input } from 'antd';

// icons
import CustomIcons from 'components/CustomIcons';

// components
import ErrorBoundary from 'engine/ErrorBoundary';

// Communication components
import {
  FBPreviewFile
} from 'components/Communications';


function FileRow({
  element,
  nameRow,
  rowsValues,
  onRemove,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-field-row', className);
  const { t, i18n } = useTranslation();


  const { key, name, ...restField } = element;
  const [rowValue, setRowValue] = useState({});

  useEffect(() => {
    setRowValue(prev => ({
      ...prev,
      ...rowsValues[name]
    }))
  }, [rowsValues]);

  const rowFileName = useMemo(() => (
    <Form.Item
      {...restField}
      name={[name, 'file-name']}
      key={[key, 'file-name']}
      rules={[
        {
          required: true,
          message: t("inputs.mandatoryField"),
          validateTrigger: "onChange",
        },
      ]}
      label={`${t("news.labelTitleOfDoc")} #${Number(name) + 1}`}
      className="file-name"
    >
      <Input placeholder={`File Name ${name}`} />
    </Form.Item>
  ), [name, key, restField, i18n?.language]);

  const rowFileUrl = useMemo(() => !!rowValue && (
    <Form.Item
      {...restField}
      name={[name, 'file-url']}
      key={[key, 'file-url']}
      rules={[
        {
          required: true,
          message: t("inputs.mandatoryField"),
        },
      ]}
      className="file-url"
    >
      <FBPreviewFile
        showTitle={false}
        file={rowValue[`file-url`]}
        name={[name, 'file-url']}
        showInput={false}
        showIcon={false}
        showIconPreview={false}
      />
    </Form.Item>
  ), [name, key, restField, rowValue, i18n?.language]);

  const rowFileActions = useMemo(() => (
    <CustomIcons className="dynamic-delete-button" type="garbage" onClick={() => onRemove(name)} />
  ), [name, onRemove]);

  return element && (
    <div className={childClassNames}>
      <ErrorBoundary>
        {rowFileName}
        {rowFileUrl}
        {!!onRemove && (rowFileActions)}
      </ErrorBoundary>
    </div>
  );
};

FileRow.defaultProps = {};
FileRow.propTypes = {
  onRemove: PropTypes.func,
};


export default memo(FileRow);
